<template>
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">
    <!-- ⚜️ ELEMENTOS DE ESQUINA DECORATIVOS -->
    <img
      src="@/assets/esq1.png"
      ref="elemTLRef"
      class="esquina esquina-tl"
      alt=""
    />
    <img
      src="@/assets/esq1.png"
      ref="elemBRRef"
      class="esquina esquina-br"
      alt=""
    />

    <!-- 🦋 MARIPOSAS ANIMADAS (ALETEO FINO EN SU LUGAR) -->
    <img
      :src="mariposaImg"
      ref="mariposa1Ref"
      class="mariposa-fija mariposa-1"
      alt=""
    />
    <img
      :src="mariposaImg"
      ref="mariposa2Ref"
      class="mariposa-fija mariposa-2"
      alt=""
    />

    <!-- IMAGEN CON RECORTE -->
    <div class="imagen-xv-wrapper" ref="mascaraRef">
      <img
        src="@/assets/foto 1_11zon_11zon (1).webp"
        ref="fotoPortadaRef"
        class="imagen-xv"
        alt="Foto protagonista"
      />
    </div>

    <!-- TEXTO -->
    <section class="texto-xv">
      <p class="frase-bendicion" ref="acompanaRef">
        As I turn <span class="honor-texto">Fifteen years old</span> I step into a beautiful new chapter of my life, carrying with me the love, lessons, and memories that have shaped who I am.
      </p>

      <div class="separador-elegante"></div>

      <p class="parrafo-presentacion" ref="quinceaneraTitleRef">
        <span class="honor-texto"> With all my heart,</span> 
        I thank my parents for their unconditional love, guidance, and support. They are my greatest blessing, and I am so grateful to begin this new journey surrounded by their love.
      </p>

      <p class="parrafo-presentacion" ref="deRef" style="margin-top: 18px;">
        <span class="honor-texto">It would be an honor to have you </span> 
        Celebrate this special milestone with me. Please join my family and me for an evening filled with love, dinner, music, and dancing as I celebrate my Quinceañera.
      </p>

      <p class="firma-despedida">With love,</p>
      <h2 class="honor-texto2" ref="nombreRef">Heidi</h2>
    </section>

    <!-- 🎀 MOÑO AL FINAL (ABAJO DE TODO) -->
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

// Importar la imagen de la mariposa
import mariposaImg from '@/assets/mariposa.png'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)
    const fotoPortadaRef = ref(null)
    const mascaraRef = ref(null)
    const acompanaRef = ref(null)
    const quinceaneraTitleRef = ref(null)
    const deRef = ref(null)
    const nombreRef = ref(null)
    const fechaRef = ref(null)
    
    // Referencias Esquinas Decorativas
    const elemTLRef = ref(null) // Top Left (elemento3)
    const florTRRef = ref(null) // Top Right
    const florBLRef = ref(null) // Bottom Left
    const elemBRRef = ref(null) // Bottom Right (elemento3)

    // Referencias directas a las mariposas
    const mariposa1Ref = ref(null)
    const mariposa2Ref = ref(null)

    onMounted(() => {
      // ---------------------------------------------------------
      // 0. ESTADO INICIAL
      // ---------------------------------------------------------
      gsap.set(mascaraRef.value, { opacity: 0, scale: 0.5, y: -20 })

      // Agrupamos las referencias para el clipPath inicial
      const todasLasEsquinas = [elemTLRef.value, florTRRef.value, florBLRef.value, elemBRRef.value].filter(Boolean)
      
      // Estado inicial para esquinas (ocultas y clipPath en 0)
      gsap.set(todasLasEsquinas, {
        opacity: 0,
        clipPath: 'polygon(0% 0%, 0% 0%, 0% 0%, 0% 0%)'
      })

      // Estado inicial de mariposas (visibles con perspectiva 3D sutil)
      gsap.set([mariposa1Ref.value, mariposa2Ref.value], {
        opacity: 0,
        transformPerspective: 800,
        transformOrigin: "center center"
      })

      // ---------------------------------------------------------
      // 1. ANIMACIÓN DE ENTRADA PRINCIPAL
      // ---------------------------------------------------------
      if (fotoPortadaRef.value) {
        gsap.from(fotoPortadaRef.value, { opacity: 0, y: 50, duration: 1.2, ease: 'power3.out' })
      }
      
      const tl = gsap.timeline({ delay: 0.4 })
      
      // Animamos el clipPath para las esquinas
      tl.to(todasLasEsquinas, {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        duration: 1.6,
        ease: 'power2.inOut'
      })
      .to([elemTLRef.value, elemBRRef.value].filter(Boolean), {
        opacity: 0.85,
        duration: 1.6,
        ease: 'power2.inOut'
      }, "<")
      .to([florTRRef.value, florBLRef.value].filter(Boolean), {
        opacity: 0.25,
        duration: 1.6,
        ease: 'power2.inOut'
      }, "<")
      
      // Entrada sutil y suave de las mariposas
      .to([mariposa1Ref.value, mariposa2Ref.value], {
        opacity: 0.85,
        duration: 1.4,
        ease: 'power2.out'
      }, "-=1.2")

      // Continuamos con el resto del contenido
      .to(mascaraRef.value, { opacity: 1, scale: 1, y: 0, duration: 1, ease: 'back.out(1.7)' }, "-=1")
      .from([acompanaRef.value, quinceaneraTitleRef.value, deRef.value].filter(Boolean), { opacity: 0, y: 25, duration: 0.8, stagger: 0.15, ease: 'power2.out' }, "-=0.4")
      .from(nombreRef.value, { opacity: 0, scale: 0.9, duration: 1.2, ease: 'power3.out' }, "-=0.3")
      if (fechaRef.value) {
        tl.from(fechaRef.value, { opacity: 0, y: 30, duration: 1, ease: 'power3.out' }, "-=0.4")
      }

      // ---------------------------------------------------------
      // 🦋 2. ANIMACIÓN DE ALETEO SÚPER FINO, DELICADO Y PAUSADO
      // ---------------------------------------------------------
      
      // Mariposa 1: Aleteo sutil y orgánico + Flotación flotante delicada
      gsap.to(mariposa1Ref.value, {
        rotateY: 15,
        scaleX: 0.8,
        duration: 0.8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })
      gsap.to(mariposa1Ref.value, {
        y: '-=3',
        x: '+=3',
        rotation: '-=2',
        duration: 0.9,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })

      // Mariposa 2: Ritmo pausado desfasado + Briso flotante
      gsap.to(mariposa2Ref.value, {
        rotateY: -25,
        scaleX: 0.9,
        duration: 0.5,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        delay: 0.4
      })
      gsap.to(mariposa2Ref.value, {
        y: '+=7',
        x: '-=4',
        rotation: '+=2.5',
        duration: 4.0,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      })
    })

    return {
      rootRef,
      fotoPortadaRef, mascaraRef, acompanaRef, quinceaneraTitleRef,
      deRef, nombreRef, fechaRef, mariposa1Ref, mariposa2Ref,
      elemTLRef, florTRRef, florBLRef, elemBRRef,
      mariposaImg
    }
  }
}
</script>
<style scoped>
.portada-xv {
  position: relative;
  width: 100%;
  min-height: 60vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: radial-gradient(circle at center, #6d0a14 0%, #3e0409 100%);
  padding: 48px 16px 56px;
}

@media (max-width: 768px) {
  .portada-xv {
    background-attachment: scroll;
  }
}

/* ⚜️ ESQUINAS DECORATIVAS */
.esquina {
  position: absolute;
  width: min(40vw, 180px);
  height: auto;
  pointer-events: none;
  z-index: 5;
}

/* Superior Izquierda */
.esquina-tl {
  top: 0;
  left: 0;
}

/* Inferior Derecha (Invertida) */
.esquina-br {
  bottom: 0;
  right: 0;
  transform: scaleX(-1) scaleY(-1);
}

/* 🦋 MARIPOSAS FIJAS CON ALETEO */
.mariposa-fija {
  position: absolute;
  width: min(14vw, 55px);
  height: auto;
  pointer-events: none;
  z-index: 6;
  transform-style: preserve-3d;
  will-change: transform;
}

.mariposa-1 {
  top: 42%;
  right: 10%;
  transform: rotate(-15deg);
}

.mariposa-2 {
  bottom: 4%;
  left: 8%;
  transform: rotate(18deg);
}

/* MARCO Y FOTO */
.imagen-xv-wrapper {
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 20px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background: #fff;
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.18),
    0 2px 8px rgba(0, 0, 0, 0.06);
  will-change: transform, filter, opacity;
}

.imagen-xv {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* TEXTOS */
.texto-xv {
  max-width: 620px;
  text-align: center;
  margin-top: 22px;
  padding: 0 8px;
  z-index: 2;
}

.frase-bendicion {
  font: clamp(1rem, 3.8vw, 1.15rem) 'quote', sans-serif;
  line-height: 1.5;
  color: #B28F60;
  margin: 20px 0 10px;
}

.separador-elegante {
  width: 110px;
  height: 2px;
  margin: 12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}

.parrafo-presentacion {
  font: clamp(1rem, 3.8vw, 1.15rem) 'quote', sans-serif;
  line-height: 1.7;
  color: #B28F60;
}

.firma-despedida {
  font-family: 'Great Vibes', cursive;
  font-size: clamp(26px, 4vw, 32px);
  color: #B28F60;
  margin: 32px 0 4px 0;
  line-height: 1;
}

.honor-texto2 {
  font-family: 'CynthiaJuneJF', cursive;
  font-size: clamp(2.3rem, 7vw, 2.3rem);
  display: block;
  line-height: 1.1;
  margin-bottom: 8px;
  color: #B28F60;
}

.honor-texto {
  font-family: 'CynthiaJuneJF', cursive;
  font-size: clamp(1.9rem, 7vw, 1.9rem);
  display: block;
  line-height: 1.1;
  margin-bottom: 8px;
  color: #fafafa;
}

/* 🎀 MOÑO INFERIOR */
.monio-inferior {
  width: min(45vw, 180px);
  height: auto;
  margin-top: 24px;
  display: block;
  z-index: 2;
  pointer-events: none;
}

@media (min-width: 992px) {
  .portada-xv {
    padding-top: 64px;
  }
  .imagen-xv-wrapper {
    margin-top: 0;
  }
}
</style>